export const TELLENT_APP_SHELL_LAYOUT = {
  sidebarMinimizedWidth: 56,
  sidebarExpandedWidth: 250,
};
